module.exports = __webpack_public_path__ + "media/images/page/service_logo-keiri-64408c6280b7973ef93140f7455860bf.png";